import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Logo } from "../components/Logo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-asphalt flex items-center justify-center px-5" data-testid="payment-cancel-page">
      <div className="w-full max-w-md bg-panel border border-[#263342] p-10 text-center">
        <div className="flex justify-center mb-6"><Logo size={40} /></div>
        <XCircle size={40} className="text-slate-500 mx-auto mb-4" />
        <h1 className="font-display font-extrabold uppercase tracking-tight text-3xl text-slate-100">Checkout cancelled</h1>
        <p className="mt-3 text-sm text-slate-400 leading-relaxed">
          No charge was made. The part is still available if you change your mind.
        </p>
        <Link
          to="/"
          data-testid="payment-cancel-home-link"
          className="mt-8 inline-block border border-slate-500 text-slate-100 font-display font-semibold uppercase tracking-widest text-sm px-8 py-3.5 hover:border-crimson hover:text-crimson transition-colors"
        >
          Back to Werkhaus
        </Link>
      </div>
    </div>
  );
}
